import * as React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';


interface IRowProps{
    gutter?: number;
}
export class Row extends React.Component<IRowProps, any>{

    render(){
        return (
            <div className={"row " }>
                {this.props.children}
            </div>
        )
    }
}

interface IColProps{
    size?: number;
    reverse?: boolean;
    span?: number;
    className?: string;
    
    style?: React.CSSProperties;
}

export class Col extends React.Component<IColProps, any>{

    
    createSpan = () => {
        var result: number[] = [];

        for(let i = 0; i < (this.props.span || 0); i++)
            result.push(1);

        return result;
    }

    render(){
       
        return (<React.Fragment>
            {
                this.createSpan().map((item, index) => 
                {
                    return <div key={'span' + index} className={`col col-1`}></div>
                })
            }
            <div style={this.props.style} className={`col col-${this.props.size} ${this.props.reverse? 'inverse':''} ${this.props.className || ''} `}>
                {this.props.children}
            </div>
            </React.Fragment>
        );
    }
}

interface IProps{
    centered?: boolean;
    padding?: number;
    style?: React.CSSProperties;
    className?: string;
    fillRow?: boolean;
    type?: 'fill' | 'flex';
    fillCount?: number;
}

export default class Grid extends React.Component<IProps, any>{

    getTypeByProps = () => {
        return this.props.type == 'fill'? `grid-fill grid-fill-${this.props.fillCount || 1} `: 'grid ' ;
    }

    render(){
        return (
            
            <div style={this.props.style} className={this.getTypeByProps() + (this.props.centered? 'centered': '') + " " + (this.props.className || '') + (this.props.fillRow? ' fill': '')}>
                
                {this.props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/core/ui/grid.tsx